import React, { useEffect, useMemo, useState } from "react";
import InteractionZone from "./InteractionZone.tsx";
import Item from "./Item.tsx";
import NPC from "./NPC.tsx";
import Player from "./Player.tsx";
import Scene from "./Scene.tsx";
import Prop from "./Prop.tsx";
import { useGameController } from "./hooks/useGameController.ts";
import ProjectorScreen from "./ProjectorScreen.tsx";
import { onPlayerJoin, insertCoin, myPlayer } from "playroomkit";
import MultiPlayer from "./MultiPlayer.tsx";
import { useAuthStore } from "./stores/auth.ts";
import { useFrame } from "@react-three/fiber";
import { Vector3 } from "three";
import Fire from "./effects/Fire.tsx";
import { Sky } from "@react-three/drei";

export default function Game({camera}){
    const authState = useAuthStore();
    const gameController = useGameController();
    const [levelKey, setLevelKey] = useState(gameController.gameState.sceneKey);
    const [currentLevel, setCurrentLevel] = useState(gameController.gameState.currentScene);
    const [sceneState, setSceneState] = useState(gameController.getGameState().sceneState);
    const [players, setPlayers] = useState([]);

    const playerInitialPosition = useMemo(() => {
        const gameState = gameController.getGameState();
        if(levelKey && gameState.currentScene){
            if(gameState.previousScene && gameState.currentScene.player.from?.[gameState.previousScene]){
                return gameState.currentScene.player.from[gameState.previousScene].position;
            } else {
                return gameState.currentScene.player.position;
            }
        }
    }, [levelKey]);

    const cameraInitialRotation = useMemo(() => {
        const gameState = gameController.getGameState();
        if(levelKey && gameState.currentScene){
            if(gameState.previousScene && gameState.currentScene.player.from?.[gameState.previousScene]){
                return gameState.currentScene.player.from[gameState.previousScene].camera;
            } else {
                return gameState.currentScene.player.camera;
            }
        }
    }, [levelKey]);

    useEffect(()=>{
        gameController.addEventHandler(["scene:updated"], 'game',(event, gameState) => {
            setSceneState({...gameState.sceneState});
            setCurrentLevel(gameState.currentScene);
        });
        gameController.addEventHandler(["scene:loaded"], 'game',(event, gameState) => {
            setLevelKey(gameState.sceneKey);
            setCurrentLevel(gameState.currentScene);
            if(gameState.sceneKey === 'school'){
                insertCoin({gameId: "Udi0K1xZk8Gq5yy2zfmU", skipLobby: true, roomCode: "1234"},()=>{
                    myPlayer().setState("username", gameController.player.username);
                });
                //maxPlayersPerRoom: 2,
        
                onPlayerJoin((player) => {
                    if(player.id == myPlayer().id) return;
                    setPlayers([...players, player]);
                    player.onQuit(() => {
                        setPlayers(players.filter(p => p.id !== player.id));
                    });
                });
            }
        });
        
        gameController.loadScene('bedroom');
        setTimeout(()=>{
        }, 3000);
    }, []);

    useFrame(()=>{
        /*if(camera.current){
          const worldPosition = new Vector3();
            camera.current.getWorldPosition(worldPosition);
            console.log("Camera World Position:", worldPosition);
        }*/
      })
    

    return currentLevel ? (
        <>
            {/*
            <pointLight position={[-10, -10, -10]} decay={0} intensity={Math.PI} />
            */}
            
            {
                /* hotfix : Could be implemented more easily, but otherwise scene Rigidbody doesn't update correctly */
                Object.values(gameController.levels).map((level: any) => <group key={level.key}>
                    <Scene isActive={level.key === levelKey} model={level.scene.model} collider={level.scene.collider_model} music={level.scene.backgroundMusic} key={level.key} />
                    {level.key === levelKey && level.scene.light?.global && (
                        <>
                            {/* Bright but less warm lighting setup */}
                            <ambientLight intensity={0.6} color="#f5f5dc"/>
                            <directionalLight 
                                position={[50, 50, 25]} 
                                intensity={1.8} 
                                color="#fff8e7"
                                castShadow
                                shadow-mapSize-width={4096 }
                                shadow-mapSize-height={4096 }
                                shadow-camera-far={100}
                                shadow-camera-left={-50}
                                shadow-camera-right={50}
                                shadow-camera-top={50}
                                shadow-camera-bottom={-50}
                                shadow-camera-near={0.1}
                                shadow-bias={-0.0001}
                                shadow-normalBias={0.2}
                            />
                            <directionalLight 
                                position={[-30, 40, -20]} 
                                intensity={0.5} 
                                color="#f0f8ff"
                                
                            />
                        </>
                    )}
                    {level.key === levelKey && <Player initialPosition={playerInitialPosition} initialRotation={currentLevel.player.rotation} cameraInitialRotation={cameraInitialRotation} scale={[1,1,1]} />}
                </group>)
            }
            {
                currentLevel.elements.map((element, index)=> {
                    if( gameController.player.inventory[currentLevel.key+index]){
                        return null;
                    }
                    if(element.sceneStateCondition){
                        const isConditionInverted = element.sceneStateCondition.indexOf('!') == 0;
                        const condition = element.sceneStateCondition.replace('!','');
                        if(isConditionInverted && sceneState[condition]){
                            return null;
                        }
                        if(!isConditionInverted && !sceneState[condition]){
                            return null;
                        }
                        /*
                        console.log("CONDITION",element.key, element.sceneStateCondition.indexOf('!'), !!(element.sceneStateCondition.indexOf('!') != 0 && !sceneState[element.sceneStateCondition]) || !!(element.sceneStateCondition.indexOf('!') == 0 && sceneState[element.sceneStateCondition]));
                        if(!!(element.sceneStateCondition.indexOf('!') != 0 && !sceneState[element.sceneStateCondition]) || !!(element.sceneStateCondition.indexOf('!') == 0 && sceneState[element.sceneStateCondition])){
                            console.log("HIDDEN", element.key);
                            return null;
                        }*/
                    }
                    switch(element.type){
                        case 'prop' : return <Prop position={element.position} rotation={element.rotation} scale={element.scale} id={element.key} key={element.uid} item={element} uid={element.uid} /> ;
                        case 'npc' : return <NPC position={element.position} rotation={element.rotation} scale={element.scale} id={element.key} key={element.uid} /> ;
                        case 'item' : return <Item position={element.position} initialRotation={element.rotation} scale={element.scale} id={element.key} data={element.data} key={element.uid} uid={element.uid} item={element}/> ;
                        case 'zone' : return <InteractionZone position={element.position} initialRotation={element.rotation} scale={element.scale} id={element.key} data={element.data} key={currentLevel.key+index} uid={element.uid} item={element}/> ;
                        case 'projector' : return <ProjectorScreen position={element.position} rotation={element.rotation} scale={element.scale} id={element.key} data={element.data} key={element.uid} uid={element.uid} /> ;
                        case 'fire' : return <Fire position={element.position} key={element.uid} /> ;
                    }
                })
            }
        </>
    ) : null
}